import { FC } from 'react';
import {
  ColumnLayout,
  Flashbar,
  SpaceBetween,
  Table
} from '@awsui/components-react';
import Moment from 'react-moment';

import ValueWithLabel from '../../../../common/ValueWithLabel';
import { IUserWorkSpaceProvisionRequest } from '../../../../../interfaces/workSpaces/userWorkSpaceProvisionRequest';
import { FlashbarProps } from '@awsui/components-react';

interface ViewProps {
  userWorkSpaceProvisionRequest: IUserWorkSpaceProvisionRequest;
  flashBarItems: FlashbarProps.MessageDefinition[];
}

const View: FC<ViewProps> = ({
  userWorkSpaceProvisionRequest,
  flashBarItems
}) => {
  const tableColumnDefinitions = [
    {
      id: 'attribute',
      header: 'Attribute',
      cell: (item: any) => item.name
    },
    {
      id: 'value',
      header: 'Value',
      cell: (item: any) => item.value
    }
  ];

  const tableItems = [
    {
      name: 'UUID',
      value: userWorkSpaceProvisionRequest.uuid || '-'
    },
    {
      name: 'Corp Email',
      value: userWorkSpaceProvisionRequest.corpEmail || '-'
    },
    {
      name: 'Directory ID',
      value: userWorkSpaceProvisionRequest.directoryId || '-'
    },
    {
      name: 'Rejection Reason',
      value: userWorkSpaceProvisionRequest.rejectionReason || '-'
    },
    {
      name: 'Justification',
      value: userWorkSpaceProvisionRequest.justification || '-'
    },
    {
      name: 'Deprecated',
      value: userWorkSpaceProvisionRequest.deprecated.toString() || '-'
    },
    {
      name: 'Created At',
      value: (
        <Moment unix local format="LLLL">
          {userWorkSpaceProvisionRequest.createdAt || '-'}
        </Moment>
      )
    },
    {
      name: 'Updated At',
      value: (
        <Moment unix local format="LLLL">
          {userWorkSpaceProvisionRequest.updatedAt || '-'}
        </Moment>
      )
    },
    {
      name: 'Updated By',
      value: userWorkSpaceProvisionRequest.updatedBy || '-'
    }
  ];

  return (
    <SpaceBetween size="xs">
      <Flashbar items={flashBarItems} />
      <SpaceBetween size="l">
        <ColumnLayout columns={3} variant="text-grid">
          <ValueWithLabel label="User Name">
            {userWorkSpaceProvisionRequest.userName || '-'}
          </ValueWithLabel>
          <ValueWithLabel label="Bundle ID">
            {userWorkSpaceProvisionRequest.bundleId || '-'}
          </ValueWithLabel>

          <ValueWithLabel label="Request Status">
            {userWorkSpaceProvisionRequest.requestStatus || '-'}
          </ValueWithLabel>
        </ColumnLayout>

        <Table columnDefinitions={tableColumnDefinitions} items={tableItems} />
      </SpaceBetween>
    </SpaceBetween>
  );
};
export default View;
